"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const columns = __importStar(require("./columns"));
exports.columns = columns;
const core = __importStar(require("./core"));
exports.core = core;
const data = __importStar(require("./data"));
exports.data = data;
const headers = __importStar(require("./headers"));
exports.headers = headers;
const icons = __importStar(require("./icons"));
const register = __importStar(require("./register"));
exports.register = register;
const themes = __importStar(require("./themes"));
exports.themes = themes;
const tools = __importStar(require("./tools"));
exports.tools = tools;
const ListGrid_1 = require("./ListGrid");
exports.ListGrid = ListGrid_1.ListGrid;
const GridCanvasHelper_1 = require("./GridCanvasHelper");
exports.GridCanvasHelper = GridCanvasHelper_1.GridCanvasHelper;
var get_internal_1 = require("./get-internal");
exports._getInternal = get_internal_1.getInternal;
/** @private */
function getIcons() {
    return icons.get();
}
exports.getIcons = getIcons;
// backward compatibility
exports.default = {
    core,
    tools,
    // impl Grids
    ListGrid: ListGrid_1.ListGrid,
    // objects
    columns,
    headers,
    themes,
    data,
    // helper
    GridCanvasHelper: GridCanvasHelper_1.GridCanvasHelper,
    //plugin registers
    register,
    get icons() {
        return getIcons();
    },
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Object.defineProperty(themes, "default", {
    enumerable: false,
    configurable: true,
    get() {
        return themes.getDefault();
    },
    set(defaultTheme) {
        themes.setDefault(defaultTheme);
    },
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Object.defineProperty(themes, "choices", {
    enumerable: false,
    configurable: true,
    get() {
        return themes.getChoices();
    },
});
